import Link from "next/link";
import { PLATFORM_VERSION } from "@/lib/constants";
import { BRAND } from "@/lib/theme/palette";

const LINK_STYLE: React.CSSProperties = {
  color: "#5f6b7a",
  textDecoration: "none",
};

export function Footer(): React.JSX.Element {
  return (
    <footer
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        marginTop: 32,
        borderTop: "1px solid #e9ebed",
        backgroundColor: "#fafafa",
        fontSize: 12,
        color: "#5f6b7a",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span
          style={{
            display: "inline-block",
            padding: "2px 8px",
            backgroundColor: BRAND.depth,
            color: "#ffffff",
            borderRadius: 3,
            fontSize: 11,
            fontWeight: 600,
          }}
        >
          RF
        </span>
        &copy; {new Date().getFullYear()} Resource Futures Ltd
        {/* Out-of-map point fix (WP07/T021+T023, consistency + axe pass): #b0bec5 on this
            footer's #fafafa background is a 1.82:1 contrast ratio (axe `color-contrast`,
            serious, found live on every page via AppShell's global Footer) — well under
            WCAG AA's 4.5:1 minimum for normal text. Reusing the footer's own already-passing
            muted-text colour (#5f6b7a, 5.2:1 here) is both the accessibility fix and the
            "one brand-adjacent muted tone" consistency fix — no new colour introduced. */}
        <span style={{ color: "#5f6b7a", marginLeft: 4 }}>
          v{PLATFORM_VERSION}
        </span>
      </span>

      <span>
        Data sources: EA Waste Data Interrogator, Defra WasteDataFlow, ONS
      </span>

      <span style={{ display: "flex", gap: 16 }}>
        <Link href="/accessibility" style={LINK_STYLE}>
          Accessibility
        </Link>
        <Link href="/terms" style={LINK_STYLE}>
          Terms
        </Link>
        <Link href="/privacy" style={LINK_STYLE}>
          Privacy
        </Link>
      </span>
    </footer>
  );
}
